import { useDispatch } from 'react-redux'
import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Stack
} from '@chakra-ui/react'
import { getNotificationMessage } from 'store'
import { REJECTED } from 'utils/constants'

export const GuestProfile = ({ isBlocked }) => {
  const item = null
  const dispatch = useDispatch()

  return (
    <Card boxShadow="none" marginTop="0px !important" background="#c4c3c7">
      <CardHeader display="flex" alignItems="center" padding="0 25px" background="#feeb88">
        <Box textAlign="left" paddingRight="10px">
          {isBlocked ? 'Blocked Request' : 'Connection Request'}
        </Box>
      </CardHeader>

      <CardBody padding="5px" minHeight="140px">
        <Box
          sx={{
            overflowX: 'auto',
            display: 'flex',
            flexDirection: 'row',
            gap: '0px'
          }}
          css={{
            '&::-webkit-scrollbar': {
              width: '4px',
              height: '10px',
              display: 'block'
            },
            '&::-webkit-scrollbar-track': {
              width: '6px'
            },
            '&::-webkit-scrollbar-thumb': {
              borderRadius: '24px',
              background: 'rgba(255, 215, 0, 1)'
            }
          }}
        >
          <Stack
            spacing="55px"
            id="connection-request-list"
            sx={{
              overflowX: 'auto',
              display: 'flex',
              flexDirection: 'row',
              gap: '0px'
            }}
            css={{
              '&::-webkit-scrollbar': {
                width: '4px',
                height: '10px',
                display: 'block'
              },
              '&::-webkit-scrollbar-track': {
                width: '6px'
              },
              '&::-webkit-scrollbar-thumb': {
                borderRadius: '24px',
                background: 'rgba(255, 215, 0, 1)'
              }
            }}
          >
            <Stack id={item?.profile_id}>
              <Box
                cursor="pointer"
                onClick={() => {
                  dispatch(getNotificationMessage({
                    type: REJECTED,
                    message: 'You must sign in or sign up to view requests',
                    isEditProfile: true
                  }))
                }}
                sx={{
                  minWidth: '120px',
                  marginTop: '5px'
                }}
                data-name="notificationItem"
                position="relative"
              >
                <div>No notifications to display</div>
              </Box>
            </Stack>
          </Stack>
        </Box>
      </CardBody>
    </Card>
  )
}
